import { useRef, useState } from 'react';
import { createContainer } from '@fuxi/eevee-hooks';

const _useGlobalState = () => {
  const ursModalRef = useRef<ModalRef>(null);
  const [jumpUrl, setJumpUrl] = useState(`${window.location.href}`);

  return {
    ursModalRef,
    jumpUrl,
    setJumpUrl,
  };
};

export const GlobalStateContainer = createContainer(_useGlobalState);
export const useGlobalState = GlobalStateContainer.useContainer;
